import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { map, switchMap, filter } from 'rxjs/operators';
import { BackendService } from '../services/backend.service';
import { ActionTypes, GetNewsItems, GetNewsItemsSuccess } from '../actions/news';
import { customerConfig } from '@uxdf/direct-shared-lib';
import { NewsItems } from '../models/news';

@Injectable()
export class EffectsNews {
  initNewsItems$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.InitNewsItems),
      map(action => new GetNewsItems(action['payload']))
    )
  });

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<any>,
    private readonly backendService: BackendService
  ) { }
}
